// 📁 utils/contactUtils.js
export function extractValidEmails(contacts) {
  return contacts
    .filter(c => c.combien > 0 && c.mail && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(c.mail))
    .map(c => c.mail.trim());
}
